var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50008 3.33341C6.11937 3.33341 5.00008 4.4527 5.00008 5.83342C5.00008 7.21413 6.11937 8.33342 7.50008 8.33342C8.88079 8.33342 10.0001 7.21413 10.0001 5.83342C10.0001 4.4527 8.88079 3.33341 7.50008 3.33341ZM3.33341 5.83342C3.33341 3.53223 5.1989 1.66675 7.50008 1.66675C9.80127 1.66675 11.6667 3.53223 11.6667 5.83342C11.6667 8.1346 9.80127 10.0001 7.50008 10.0001C5.1989 10.0001 3.33341 8.1346 3.33341 5.83342Z",
    fill: "#9E9B99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83342 13.3334C4.4527 13.3334 3.33341 14.4527 3.33341 15.8334V17.5001C3.33341 17.9603 2.96032 18.3334 2.50008 18.3334C2.03984 18.3334 1.66675 17.9603 1.66675 17.5001V15.8334C1.66675 13.5322 3.53223 11.6667 5.83342 11.6667H9.16675C11.4679 11.6667 13.3334 13.5322 13.3334 15.8334V17.5001C13.3334 17.9603 12.9603 18.3334 12.5001 18.3334C12.0398 18.3334 11.6667 17.9603 11.6667 17.5001V15.8334C11.6667 14.4527 10.5475 13.3334 9.16675 13.3334H5.83342Z",
    fill: "#9E9B99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5261 2.40172C12.6403 1.95586 13.0943 1.68697 13.5401 1.80112C15.3838 2.27318 16.6733 3.93445 16.6733 5.83758C16.6733 7.74072 15.3838 9.40199 13.5401 9.87404C13.0943 9.9882 12.6403 9.7193 12.5261 9.27345C12.412 8.82759 12.6809 8.37361 13.1267 8.25946C14.2329 7.97623 15.0066 6.97946 15.0066 5.83758C15.0066 4.6957 14.2329 3.69894 13.1267 3.41571C12.6809 3.30155 12.412 2.84757 12.5261 2.40172Z",
    fill: "#9E9B99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1932 12.4168C14.3083 11.9711 14.7628 11.7032 15.2084 11.8182C17.0395 12.291 18.3225 13.9376 18.3334 15.8286L18.3334 15.8334L18.3334 17.5001C18.3334 17.9603 17.9603 18.3334 17.5001 18.3334C17.0398 18.3334 16.6667 17.9603 16.6667 17.5001V15.836C16.6592 14.7023 15.8897 13.7154 14.7918 13.432C14.3461 13.3169 14.0782 12.8624 14.1932 12.4168Z",
    fill: "#9E9B99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.b50bcd918e5c4edeac0583beec67237c.svg";
export { ForwardRef as ReactComponent };